<div class="ABC-loader">
  <div class="loadingImage"></div>
</div>
